import { sift, unique } from 'radash'

import { Feature } from '@wwt/entities/search-response'

import { EXCLUDE_REMOTE_TAB_NAMES } from '../config'

export const extractRemoteTabNames = (features: Feature[]): string[] => {
	return unique(
		sift(
			features.map(feature => {
				const tabName = feature.group?.tabName
				return tabName && !EXCLUDE_REMOTE_TAB_NAMES.includes(tabName)
					? tabName
					: undefined
			})
		)
	)
}
